
export default () => {
	return (
		<svg
			width="480px"
			height="512px"
			viewBox="0 0 480 512"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g
				id="Page-1"
				stroke="none"
				stroke-width="1"
				fill="none"
				fill-rule="evenodd"
			>
				<g id="box" fill-rule="nonzero">
					<path
						d="M233.03,10.865 L12.063,117.537 C9.293,118.874 7.532,121.68 7.532,124.756 L7.532,387.241 C7.532,390.317 9.293,393.122 12.063,394.46 L233.03,501.135 C237.434,503.261 242.566,503.261 246.97,501.135 L467.937,394.461 C470.707,393.124 472.468,390.318 472.468,387.242 L472.468,124.757 C472.468,121.681 470.707,118.876 467.937,117.538 L246.97,10.865 C242.566,8.739 237.434,8.739 233.03,10.865 Z"
						id="Path"
						fill="#C4A6FF"
					></path>
					<path
						d="M8.865,120.368 C8.022,121.651 7.532,123.161 7.532,124.756 L7.532,387.241 C7.532,390.318 9.293,393.122 12.063,394.46 L233.03,501.135 C235.232,502.198 237.616,502.73 240,502.73 L240,231.951 L8.865,120.368 Z"
						id="Path"
						fill="#8A50FF"
					></path>
					<path
						d="M471.135,120.368 C471.978,121.651 472.468,123.161 472.468,124.756 L472.468,387.241 C472.468,390.318 470.707,393.122 467.937,394.46 L246.97,501.135 C244.768,502.198 242.384,502.73 240,502.73 L240,231.951 L471.135,120.368 Z"
						id="Path"
						fill="#8A50FF"
					></path>
					<polygon
						id="Path"
						fill="#FF8087"
						points="392.807 158.052 160.86 46 99.718 75.636 332.185 187.863"
					></polygon>
					<path
						d="M332.185,187.863 L332.185,274.803 C332.185,277.758 335.274,279.697 337.936,278.412 L388.276,254.11 C391.047,252.773 392.807,249.967 392.807,246.891 L392.807,158.052 L332.185,187.863 Z"
						id="Path"
						fill="#E6646E"
					></path>
					<path
						d="M475.697,112.9695 L243.229,0.7455 C241.168,-0.2485 238.768,-0.2485 236.708,0.7455 L4.239,112.9695 C1.647,114.2205 2.84217094e-14,116.8455 2.84217094e-14,119.7235 L2.84217094e-14,392.2725 C2.84217094e-14,395.1505 1.647,397.7755 4.239,399.0265 L236.707,511.2525 C237.737,511.7495 238.853,511.9985 239.968,511.9985 C241.083,511.9985 242.198,511.7495 243.229,511.2525 L475.697,399.0265 C478.289,397.7755 479.936,395.1505 479.936,392.2725 L479.936,119.7245 C479.936,116.8455 478.288,114.2215 475.697,112.9695 Z M239.968,15.8275 L455.185,119.7245 L392.798,149.8425 C392.403,149.5415 391.986,149.2635 391.528,149.0425 L177.773,45.8525 L239.968,15.8275 Z M160.835,54.3325 L375.739,158.0785 L331.724,179.3275 L116.909,75.6225 L160.835,54.3325 Z M339.654,192.1555 L380.767,172.3075 L380.767,250.8535 L339.654,270.7015 L339.654,192.1555 Z M247.468,492.5505 L247.468,236.6575 L299.341,211.6155 C303.071,209.8145 304.635,205.3315 302.834,201.6005 C301.033,197.8715 296.55,196.3055 292.819,198.1075 L239.968,223.6225 L219.172,213.5825 C215.441,211.7795 210.958,213.3455 209.157,217.0755 C207.356,220.8055 208.92,225.2895 212.65,227.0905 L232.468,236.6575 L232.468,492.5505 L15,387.5655 L15,131.6725 L180.6,211.6175 C181.651,212.1255 182.762,212.3655 183.855,212.3655 C186.643,212.3655 189.321,210.8035 190.614,208.1245 C192.415,204.3945 190.851,199.9105 187.121,198.1095 L24.751,119.7235 L99.256,83.7555 L324.55,192.5195 C324.583,192.5655 324.62,192.6065 324.654,192.6515 L324.654,282.6505 C324.654,285.2315 325.981,287.6305 328.167,289.0035 C329.381,289.7655 330.766,290.1505 332.155,290.1505 C333.267,290.1505 334.382,289.9035 335.415,289.4045 L391.528,262.3155 C394.12,261.0645 395.767,258.4405 395.767,255.5615 L395.767,165.0665 L464.936,131.6745 L464.936,387.5675 L247.468,492.5505 Z"
						id="Shape"
						fill="#000000"
					></path>
					<path
						d="M217.87774,421.217612 L183.76274,404.748612 C180.03074,402.945612 175.54874,404.511612 173.74774,408.241612 C171.94674,411.971612 173.51074,416.455612 177.24074,418.256612 L211.35574,434.725612 C212.40674,435.233612 213.51774,435.473612 214.61074,435.473612 C217.39874,435.473612 220.07674,433.911612 221.36974,431.232612 C223.17174,427.501612 221.60774,423.018612 217.87774,421.217612 Z"
						id="Path"
						fill="#000000"
					></path>
					<path
						d="M218.227111,455.351718 L152.762111,423.747718 C149.031111,421.946718 144.548111,423.510718 142.747111,427.241718 C140.947111,430.971718 142.511111,435.455718 146.241111,437.256718 L211.706111,468.860718 C212.757111,469.367718 213.868111,469.608718 214.961111,469.608718 C217.749111,469.608718 220.427111,468.046718 221.720111,465.367718 C223.521111,461.636718 221.957111,457.151718 218.227111,455.351718 Z"
						id="Path"
						fill="#000000"
					></path>
				</g>
			</g>
		</svg>
	);
};
